import { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";

const DISMISS_KEY = "eo_install_dismissed";
const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export function InstallPrompt() {
  const [deferred, setDeferred] = useState(() => window.__eoInstallEvent || null);
  const [ios, setIos] = useState(false);
  const [hidden, setHidden] = useState(() => isStandalone() || localStorage.getItem(DISMISS_KEY) === "1");

  useEffect(() => {
    if (hidden) return undefined;
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => setHidden(true);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    if (isIOS()) setIos(true);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, [hidden]);

  const dismiss = () => { localStorage.setItem(DISMISS_KEY, "1"); setHidden(true); };
  const install = async () => {
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    setDeferred(null);
    if (outcome === "accepted") setHidden(true);
  };

  if (hidden || (!deferred && !ios)) return null;
  return (
    <div data-testid="install-prompt" className="fixed top-[66px] sm:top-auto sm:bottom-6 left-3 right-3 sm:left-auto sm:right-6 sm:w-[380px] z-[60] bg-white border border-[#1D3557] shadow-xl p-4 flex gap-3 eo-no-print">
      <img src="/icon-192.png" alt="" className="w-11 h-11 shrink-0 border border-[#DCD9D0]" />
      <div className="min-w-0 flex-1">
        <div className="font-heading font-bold text-[15px]">Install DCPPL E-docs</div>
        {deferred ? (
          <>
            <div className="text-[12.5px] text-[#5C5C54] mt-0.5">Add it to your home screen and open files like a normal app.</div>
            <button data-testid="install-prompt-btn" onClick={install} className="eo-btn-primary mt-3 h-9 flex items-center gap-1.5 text-[13px]"><Download size={14} /> Install app</button>
          </>
        ) : (
          <div data-testid="install-prompt-ios" className="text-[12.5px] text-[#5C5C54] mt-0.5 leading-relaxed">
            Tap <Share size={13} className="inline -mt-0.5 text-[#1D3557]" /> <b>Share</b> in Safari, then <b>Add to Home Screen</b>.
          </div>
        )}
      </div>
      <button data-testid="install-prompt-dismiss" onClick={dismiss} aria-label="Dismiss" className="self-start p-1 text-[#8A8A80] hover:text-[#0A0A0A]"><X size={16} /></button>
    </div>
  );
}
